import ReactDOM from "react-dom";
import React, {Fragment} from "react";
import { Swiper, SwiperSlide } from 'swiper/react'; 
  

import CompareBlock from './Components/CompareBlock'
import Axios from "axios";

const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";


export default  class Breeds extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dogsObjectResult:[],
            queryOne:'',
            queryTwo:'',
            chooseOne:{},
            chooseTwo:{},
            step:0,
            staticImg: 'https://dt-petpassion-dgthouse.s3.amazonaws.com/s/breeds/'


        }

        this.renderSlide = this.renderSlide.bind(this); 
        this.getDataCompareSplit = this.getDataCompareSplit.bind(this); 
         
    }
    componentDidMount() {
        Axios.get('/confronto-razze/getall').
            then( (data) => {
                let result = data.data.data.number.results ;
                console.log(data.data.data.number.results);
                //pet_breed.name
                this.setState({ dogsObjectResult: result })
        } )
    }

    renderSlide(){ 
        let list = [];

        // FILTRO SU LISTA OBJET DOGS 
        // DA EVITARE IL FILTRO TERNARIO DOPO AVER SELEZIONATO ENTRAMBE LE SCELTE.. 
        
        // 1) attivo primo input search
        if( 0 == this.state.step ) {
            list = this.state.queryOne === '' ?
                this.state.dogsObjectResult :
                this.state.dogsObjectResult.filter( item => item["breed.name"].toLowerCase().includes( this.state.queryOne.toLowerCase() ) )
        } else {
            list = this.state.queryTwo === '' ?
                this.state.dogsObjectResult :
                this.state.dogsObjectResult.filter( item => item["breed.name"].toLowerCase().includes( this.state.queryTwo.toLowerCase() ) )
        }

      const data = list.map((item,index) => {

          let state = {
              [ this.state.step == 0 ? 'chooseOne' : 'chooseTwo'  ] : item ,
              [ this.state.step == 0 ? 'queryOne' : 'queryTwo'  ] : item["breed.name"],
              step: this.state.step == 0 ? 1 : 0
          };

            return(
                <SwiperSlide onClick={ ()=> this.setState( state ) }    key={index} className={''}>
                    <div className={'containerImage'} style={{   }}>  


                    <img style={{width:'100%' }} className={'dog-image'} onError={(e)=>{
                                        e.target.src= ASSETS_BASE + "/images/placeholder-s-cani.png"
                                    }}  src={ this.state.staticImg + item["breed.name"] + '.png'} />
 
                       <p className={'nameDog'}> { item["breed.name"] } </p>
                        {/* <p> Taglia: { item["breed.size"] } </p>
                        <p> Long: { item["breed.longevity"] } </p> */}
                        </div>
                </SwiperSlide>
            )
        });
    return data;

    }

    getDataCompareSplit(stringa){
       if(stringa){

            let newString = stringa.split(',',6);
            let femmina = newString[0].split('Femmina=',2);
            let maschio = newString[1].split(' Maschio=',2); 
             console.log([femmina,maschio])
           return [femmina,maschio]
       }
    }


   


    render(){
        // this.state.chooseTwo['breed.name']
        const { chooseTwo, chooseOne } = this.state;
        let visibileBlockChooseDogs  = ( Object.keys(this.state.chooseOne).length > 0  && Object.keys(this.state.chooseTwo).length > 0 ) ? true : false ;

        return (
            <Fragment>
                <div id="header-breeds" className={""}>
                    <img className={'img-header'}  src={ ASSETS_BASE+'/images/head-confronto-razze.png'}   />
                </div> 

                <div id="title-desc-breeds" style={{ maxWidth:'500px',margin:'0 auto' }}className={""}>
                    <h2 style={{ fontSize:'30px' }} >RAZZE DI CANI A CONFRONTO </h2>
                    <p  style={{ fontSize:'19px',color:'grey',paddingTop:'5px',paddingBottom:'8px' }} >Confronta le caratteristiche
                        delle diverse razze per trovare
                        l'amico a quattro zampe
                        più adatto a te!</p>
               
                </div>

                <div id="content-breeds" className={""}>
                    {/* first block choose */}
                    <div className={"item"} >
                        <img id={'first-img-dog-choose'}  className={'img-dog-search'}  src={ ASSETS_BASE+'/images/dog-compare-first.png'} />
                        <img id={'first-img-dog-choose-change'} onError={(e)=>{
                                        e.target.src= ASSETS_BASE + "/images/placeholder-s-cani.png"
                                    }}  src={ this.state.staticImg + this.state.chooseOne['breed.name']+'.png' } className={'img-selected'} />
                        <input className={'search-dog-first'} type={'text'}
                        onChange={(e)=>  this.setState({ queryOne :e.target.value , step:0 })  }
                            value={this.state.queryOne} placeholder="Seleziona la razza" />
                    <div style={{display:'inline-block',width:'100%'}} >

                        <a id={'first-got-to-art'} className={'goto_article'} href={ chooseOne['breed.article_url'] } >Scopri di piu</a>
                        </div>
                        <div style={{marginTop:'15px' ,textAlign:'right', marginRight:'10px'}}>
                            <p id={'#testoCambiaRazzeOne'}  style={{}} >Cambia la razza da confrontare</p>
                            <button id={'edtiIconOne'} className={'editDogIcon'} onClick={ ()=>{
                                this.setState({
                                    chooseOne:{},queryOne:'',step:0
                                })
                            } }><span className={"glyphicon glyphicon-pencil editDog"} aria-hidden="true"></span></button>
                        </div>
                         
                    </div>
                    
                    {/* second block choose */} 
                    <div  className={"item"} >
                        <img id={'second-img-dog-choose'} className={'img-dog-search'} src={ASSETS_BASE + '/images/dog-ricorsiva.png'} />
                        <img  id={'second-img-dog-choose-change'}  onError={(e)=>{
                                        e.target.src= ASSETS_BASE + "/images/placeholder-s-cani.png"
                                    }}  src={ this.state.staticImg + this.state.chooseTwo['breed.name']+'.png' } className={'img-selected'}  />

                        <input className={'search-dog-second'}   onChange={(e)=>  this.setState({ queryTwo:e.target.value, step:1 })  }
                               value={this.state.queryTwo}  type={'text'} placeholder="Seleziona la razza" />
                        <div style={{display:'inline-block',width:'100%'}}  > 
                        <a id={'sec-got-to-art'} className={'goto_article'} href={ chooseTwo['breed.article_url'] } >Scopri di piu</a>
                        </div>
                        <div style={{marginTop:'15px',textAlign:'left',marginLeft:'10px'}}>
                            <p  id={'#testoCambiaRazzeTwo'}   >Cambia la razza da confrontare</p>
                            <button id={'edtiIconTwo'} className={'editDogIcon'} onClick={ ()=>{
                                this.setState({
                                    chooseTwo:{},queryTwo:'',step:1
                                })
                            } }><span className={"glyphicon glyphicon-pencil editDog"} aria-hidden="true"></span></button>
                        </div>
                    </div>

                </div>
 
                <div id="content-breeds-slider-dog" className={""}> 
                    <p style={{paddingTop:'10px',paddingBottom:'10px', color:'#ffffff',fontSize:'25px', fontWeight:'bold'}} >Clicca sul riquadro per selezionare la razza</p>
                     
                </div> 
                {
                    !visibileBlockChooseDogs && (
                        <div className={'content-slide'}>
                        <Swiper 
                            slidesPerView={2}
                            spaceBetween={20}
                            centeredSlides={true}
                            //cssMode={true}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                            breakpoints={{
                                // when window width is >= 640px
                                640: {
                                  width: 640,
                                  slidesPerView: 3  ,
                                  spaceBetween: 20
                                }
                              }} 
                              >  {
                                this.renderSlide()
                            }
                        </Swiper>
    
                    </div>
                    )
                }   {

                    visibileBlockChooseDogs && (
 
                        <div>
                             
                            {/* //breed.dimensions */}
                            <CompareBlock  
                                blockType={'1'}
                                
                                titleCompare={'DIMENSIONI'} 
                                titleColLeft={'Femmina'} 
                                titleColRight={'Femmina'}
                                dataLeft={this.getDataCompareSplit(chooseOne['breed.dimensions'])[0]}
                                dataRight={ this.getDataCompareSplit(chooseTwo['breed.dimensions'])[0]  }

                                titleColLeft_2={'Maschio'} 
                                titleColRight_2={'Maschio'}
                                dataLeft_2={this.getDataCompareSplit(chooseOne['breed.dimensions'])[1]}
                                dataRight_2={ this.getDataCompareSplit(chooseTwo['breed.dimensions'])[1]  } 
                                />

                            {/* //breed.weight */}
                            <CompareBlock  
                                blockType={'1'}
                                 
                                titleCompare={'PESO'} 
                                titleColLeft={'Femmina'} 
                                titleColRight={'Femmina'}
                                dataLeft={ this.getDataCompareSplit(chooseOne['breed.weight'])[0]  }
                                dataRight={this.getDataCompareSplit(chooseTwo['breed.weight'])[0] }
    
                                titleColLeft_2={'Maschio'} 
                                titleColRight_2={'Maschio'}
                                dataLeft_2={this.getDataCompareSplit(chooseOne['breed.weight'])[1]}
                                dataRight_2={this.getDataCompareSplit(chooseTwo['breed.weight'])[1]} 
                            />
                            {/* //breed.longevity */}
                            <CompareBlock  
                                blockType={'1'}
                                titleCompare={'ASPETTATIVA DI VITA'} 
                                titleColLeft={'Anni'} 
                                titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.longevity'] }
                                dataRight={ chooseTwo['breed.longevity']}
                            />
                             {/* //breed.longevity */}
                            <CompareBlock  
                                blockType={'1'}
                                titleCompare={'TAGLIA'} 
                                // titleColLeft={'Anni'} 
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.size'] }
                                dataRight={ chooseTwo['breed.size']}
                            />
                            {/* //breed.longevity */}
                            <CompareBlock  
                                blockType={'2'}
                                titleCompare={'ATTIVITA FISICA'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_bisogno_attività'] }
                                dataRight={ chooseTwo['breed.attr_bisogno_attività'] }
                            />
                            {/* breed.ideal_context */}
                            <CompareBlock  
                                blockType={'1'}
                                titleCompare={'LUOGO IDEALE'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.ideal_context'] }
                                dataRight={ chooseTwo['breed.ideal_context'] }
                            />

                            <CompareBlock  
                                blockType={'2'}
                                titleCompare={'SOCIEVOLE CON I BAMBINI'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_socievole_bambini'] }
                                dataRight={ chooseTwo['breed.attr_socievole_bambini'] }
                            />

                            <CompareBlock  
                                blockType={'2'}
                                titleCompare={'SOCIEVOLE CON ALTRI ANIMALI'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_socievole_animali'] }
                                dataRight={ chooseTwo['breed.attr_socievole_animali'] }
                            />

                    <CompareBlock  
                                blockType={'2'}
                                titleCompare={'ADATTO COME PRIMO CANE'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_primo_cane'] }
                                dataRight={ chooseTwo['breed.attr_primo_cane'] }
                            />
                            <CompareBlock  
                                blockType={'2'}
                                titleCompare={'VOCALIZZI'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_abbaia'] }
                                dataRight={ chooseTwo['breed.attr_abbaia'] }
                            />
                               <CompareBlock  
                                blockType={'2'}
                                titleCompare={'AFFETTUOSO'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_affettuoso'] }
                                dataRight={ chooseTwo['breed.attr_affettuoso'] }
                            />
                                {/* <CompareBlock  
                                blockType={'2'}
                                titleCompare={'TERRITORIALE'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_affettuoso'] }
                                dataRight={ chooseTwo['breed.attr_affettuoso'] }
                            /> */}
                            <CompareBlock  
                                blockType={'2'}
                                titleCompare={'CURA DEL PELO'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_cura_pelo'] }
                                dataRight={ chooseTwo['breed.attr_cura_pelo'] }
                            />

                        <CompareBlock  
                                blockType={'2'}
                                titleCompare={'INDIPENDENTE'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_indipendente'] }
                                dataRight={ chooseTwo['breed.attr_indipendente'] }
                            />
                             <CompareBlock  
                                blockType={'2'}
                                titleCompare={'INTELLIGENTE'} 
                                // titleColLeft={'Anni'}   
                                // titleColRight={'Anni'}
                                dataLeft={  chooseOne['breed.attr_intelligente'] }
                                dataRight={ chooseTwo['breed.attr_intelligente'] }
                            />
                            
                            
                        </div> 
                    )
                }

{     this.getDataCompareSplit() }
                
            </Fragment>
        )
    }
}




document.addEventListener("DOMContentLoaded", () => {
    const mountPoint = document.getElementById("breeds-content");
    if(mountPoint)
        ReactDOM.render(<Breeds />, mountPoint);
});
